/*
 * Stores optionally supplied cello ucc referral code in local storage
 */

export default defineNuxtRouteMiddleware(to => {
  if (to.name === 'business-signup' && to.query.ucc) {
    localStorage.setItem('ucc', to.query.ucc as string)
  }
})
